import { Helmet } from 'react-helmet-async';
import './StaticPages.css';

export default function Terms() {
  return (
    <div className="static-page">
      <Helmet><title>Terms & Conditions - MiniMom Co</title></Helmet>
      <div className="static-page-header">
        <h1>Terms & Conditions</h1>
        <p>Last updated: April 2026</p>
      </div>
      <div className="static-page-content">
        <section className="static-section">
          <h2>1. Introduction</h2>
          <p>
            Welcome to MiniMom Co. These Terms and Conditions govern your use of our website and the purchase
            of products from our online store. By accessing or using our website, you agree to be bound by
            these terms. If you do not agree, please do not use our services.
          </p>
        </section>

        <section className="static-section">
          <h2>2. Eligibility</h2>
          <p>
            You must be at least 18 years of age to make a purchase on our website. By placing an order, you
            represent that you are of legal age and have the authority to enter into a binding agreement.
          </p>
        </section>

        <section className="static-section">
          <h2>3. Products & Pricing</h2>
          <p>
            We strive to display accurate product descriptions, images, and pricing. However, we do not
            warrant that product descriptions or other content is accurate, complete, or error-free. Prices
            are listed in Indian Rupees (₹) and are subject to change without prior notice. Promotional
            prices are valid only during the specified promotion period.
          </p>
        </section>

        <section className="static-section">
          <h2>4. Orders & Payment</h2>
          <p>
            When you place an order, you are making an offer to purchase the product(s). We reserve the right
            to accept or decline your order. Payment must be made in full at the time of order placement.
            We accept major credit/debit cards, UPI, net banking, digital wallets, and Cash on Delivery
            (where available).
          </p>
        </section>

        <section className="static-section">
          <h2>5. Shipping & Delivery</h2>
          <p>
            We aim to dispatch all orders within 1-2 business days. Delivery timelines are estimates and
            may vary based on your location and other factors. MiniMom Co is not responsible for delays
            caused by shipping carriers, customs, or unforeseen circumstances.
          </p>
        </section>

        <section className="static-section">
          <h2>6. Returns & Refunds</h2>
          <p>
            We offer a 15-day return policy from the date of delivery. Items must be unused, unwashed, and
            in their original packaging with all tags attached. Refunds will be processed within 5-7 business
            days after the returned item is received and inspected. Shipping charges are non-refundable.
          </p>
        </section>

        <section className="static-section">
          <h2>7. Intellectual Property</h2>
          <p>
            All content on this website — including logos, images, text, graphics, and software — is the
            property of MiniMom Co and is protected by copyright and intellectual property laws. You may not
            reproduce, distribute, or create derivative works without our prior written consent.
          </p>
        </section>

        <section className="static-section">
          <h2>8. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, MiniMom Co shall not be liable for any indirect,
            incidental, special, or consequential damages arising from your use of our website or products.
            Our total liability shall not exceed the amount paid by you for the relevant product.
          </p>
        </section>

        <section className="static-section">
          <h2>9. Changes to Terms</h2>
          <p>
            We reserve the right to update these Terms and Conditions at any time. Changes will be posted
            on this page with an updated "Last updated" date. Continued use of our website after changes
            constitutes acceptance of the revised terms.
          </p>
        </section>

        <section className="static-section">
          <h2>10. Contact Us</h2>
          <p>
            If you have any questions about these Terms and Conditions, please contact us at
            support@minimomco.com or through our Support page.
          </p>
        </section>
      </div>
    </div>
  );
}
